<!--
 ======= Action Card =======

Props:
  - use "route" property when is a vue router link
  - use "url" property when is an external url
  - use @click callback when is an internal action

Examples:
  - Router Link
    <action-card
      title="Title"
      icon="font-awesome-icon-name"
      :route="{ name: 'route-name' }"
    />

  - External URL
    <action-card
      title="Title"
      icon="font-awesome-icon-name"
      url="https://querobolsa.com.br"
    />

  - Internal Action
    <action-card
      title="Title"
      icon="font-awesome-icon-name"
      @click="doSomething()"
    />
 -->

<template>
  <component
    :is="tag"
    :to="routeProps"
    :href="url"
    :target="target"
    :class="{ 'action-card--small': small }"
    class="z-card z-card--with-hover z-card--small action-card"
    tag="div"
    @click="emitClick()"
  >
    <z-icon size="extra-large" :icon="[iconPrefix, icon]" color="primary" />
    <div class="z-text z-text--bold">
      {{ this.title }}
    </div>
  </component>
</template>

<style lang="scss" scoped>

.action-card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 144px;

  @media (min-width: $screen-md-min) {
    min-height: 117px;
  }
}

.action-card--small {
  min-height: 56px;
}
</style>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    iconPrefix: {
      type: String,
      default: 'fal',
    },
    title: {
      type: String,
      required: true,
    },
    route: {
      type: Object,
      default: () => (null),
    },
    url: {
      type: String,
      default: null,
    },
    newTab: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tag() {
      if (this.route) return 'router-link';
      if (this.url) return 'a';
      return 'div';
    },
    routeProps() {
      if (!this.route) return null;
      return { name: this.route.name, params: this.route.params, query: this.route.query };
    },
    target() {
      if (this.newTab) return '_blank';
      return '';
    },
  },
  methods: {
    emitClick() {
      this.$emit('click');
    },
  },
};
</script>
